/**
 * MOD Animations by frames - configured in LYRA
 */
import { 
	stageEntry, immediateEntry, stageLeave,
	stageMultipleLayerEntry, stageMultipleLayerLeave
} from './mod.animations.helper';

/**
 * Animation Object
 */
export const animations: any = {
	'mod-frame-flow-chart': () => {
		return {
			enter: () => stageEntry('.js-mod-frame-flow-chart'),
			leave: () => stageLeave('.js-mod-frame-flow-chart'),
		}
	},
	'mod-frame-molecule-overview': () => {
		return {
			enter: () => immediateEntry('.js-mod-frame-molecule-overview'),
			leave: () => stageLeave('.js-mod-frame-molecule-overview'),
		}
	},
	'mod-frame-many-molecules': () => {
		return {
			enter: () => {
				immediateEntry('.js-mod-frame-many-molecule-element')
			},
			leave: () => stageLeave('.js-mod-frame-many-molecule-element'),
		}
	},
	'mod-frame-enter-body': () => {
		return {
			enter: () => stageMultipleLayerEntry('.js-mod-frame-enter-body-human', 'stage-1'),
			leave: () => stageMultipleLayerLeave('.js-mod-frame-enter-body-human'),
		}
	},
	'mod-frame-human-body': () => {
		return {
			enter: () => stageMultipleLayerEntry('.js-mod-frame-enter-body-human', 'stage-2'),
			leave: () => stageMultipleLayerLeave('.js-mod-frame-enter-body-human'),
		}
	},
	'mod-frame-human-kidney': () => {
		return {
			enter: () => stageMultipleLayerEntry('.js-mod-frame-enter-body-human', 'stage-3'),
			leave: () => stageMultipleLayerLeave('.js-mod-frame-enter-body-human'),
		}
	},
	'mod-frame-human-neuronal-cells': () => {
		return {
			enter: () => stageMultipleLayerEntry('.js-mod-frame-enter-body-human', 'stage-4'),
			leave: () => stageMultipleLayerLeave('.js-mod-frame-enter-body-human'),
		}
	},
	'mod-frame-human-organs': () => {
		return {
			enter: () => stageMultipleLayerEntry('.js-mod-frame-enter-body-human', 'stage-5'),
			leave: () => stageMultipleLayerLeave('.js-mod-frame-enter-body-human'),
		}
	},
	'mod-frame-virus-entry': () => {
		return {
			enter: () => immediateEntry('.js-mod-frame-virus-entry'),
			leave: () => stageLeave('.js-mod-frame-virus-entry'),
		}
	},
	'mod-frame-virus-infusion': () => {
		return {
			enter: () => immediateEntry('.js-mod-frame-virus-infusion'),
			leave: () => stageLeave('.js-mod-frame-virus-infusion'),
		}
	},
	'mod-frame-virus-rna': () => {
		return {
			enter: () => immediateEntry('.js-mod-frame-virus-rna'),
			leave: () => stageLeave('.js-mod-frame-virus-rna'),
		}
	},
	'mod-frame-breakdown': () => {
		return {
			enter: () => stageMultipleLayerEntry('.js-mod-frame-breakdown', 'stage-1'),
			leave: () => stageMultipleLayerLeave('.js-mod-frame-breakdown'),
		}
	},
	'mod-frame-encoded-protease': () => {
		return {
			enter: () => stageMultipleLayerEntry('.js-mod-frame-breakdown', 'stage-2'),
			leave: () => stageMultipleLayerLeave('.js-mod-frame-breakdown'),
		}
	},

	'mod-frame-encoded-protease-v2': () => {
		return {
			enter: () => {
				stageMultipleLayerEntry('.js-mod-frame-breakdown', 'stage-3');
				immediateEntry('.js-mod-frame-encoded-v2');
			},
			leave: () => {
				stageMultipleLayerLeave('.js-mod-frame-breakdown');
				stageLeave('.js-mod-frame-encoded-v2');
			}
		}
	},
	'mod-frame-encoded-protease-v3': () => {
		return {
			enter: () => {
				stageMultipleLayerEntry('.js-mod-frame-breakdown', 'stage-3');
				immediateEntry('.js-mod-frame-encoded-v2');
			},
			leave: () => {
				stageMultipleLayerLeave('.js-mod-frame-breakdown');
				stageLeave('.js-mod-frame-encoded-v2');
			}
		}
	},
	'mod-frame-mutagenesis': () => {
		return {
			enter: () => immediateEntry('.js-mod-frame-mutagenesis'),
			leave: () => stageLeave('.js-mod-frame-mutagenesis'),
		}
	},
	'mod-frame-replicase': () => {
		return {
			enter: () => stageMultipleLayerEntry('.js-mod-frame-rna-replication', 'stage-1'),
			leave: () => stageMultipleLayerLeave('.js-mod-frame-rna-replication'),
		}
	},
	'mod-frame-rna-target': () => {
		return {
			enter: () => stageMultipleLayerEntry('.js-mod-frame-rna-replication', 'stage-2'),
			leave: () => stageMultipleLayerLeave('.js-mod-frame-rna-replication'),
		}
	},
	'mod-frame-protein-analysis': () => {
		return {
			enter: () => stageMultipleLayerEntry('.js-mod-frame-rna-replication', 'stage-3'),
			leave: () => stageMultipleLayerLeave('.js-mod-frame-rna-replication'),
		}
	},
	'mod-frame-membrane': () => {
		return {
			enter: () => immediateEntry('.js-mod-frame-membrane'),
			leave: () => stageLeave('.js-mod-frame-membrane'),
		}
	},
	'mod-frame-vitamin-release': () => {
		return {
			enter: () => immediateEntry('.js-mod-frame-vitamin-release'),
			leave: () => stageLeave('.js-mod-frame-vitamin-release'),
		}
	},
	'mod-frame-exit': () => {
		return {
			enter: () => immediateEntry('.js-mod-frame-vitamin-exit'),
			leave: () => stageLeave('.js-mod-frame-vitamin-exit'),
		}
	},
	'mod-credits': () => {
		return {
			enter: () => immediateEntry('.js-mod-credits'),
			leave: () => stageLeave('.js-mod-credits'),
		}
	}
};